import { ChartType, Colors, Styles, } from '@realize-reports/shared-charts';
import { Locale } from '../../../shared/models/common.model';
import * as i0 from "@angular/core";
import * as i1 from "../realize-overview-data/realize-overview-data.service";
export class RealizeOverviewService {
    constructor(realizeOverviewDataService) {
        this.realizeOverviewDataService = realizeOverviewDataService;
        this.districtIds = [];
        this.districtName = '';
        this.organizationIds = '';
        this.columnChartCommonAxisLabelStyle = {
            fontSize: Styles.FONT_SIZE_12,
            fontFamily: Styles.OPEN_SANS,
            color: Colors.BLACK,
        };
        this.columnChartCommonXAxisConfigs = {
            lineWidth: 1,
            lineColor: Colors.BLACK,
            labelRotation: -45,
            labelsEnabled: true,
        };
        this.columnChartCommonYAxisConfigs = {
            lineWidth: undefined,
            lineColor: Colors.BLACK,
            tickAmount: 6,
            tickColor: Colors.WHITE_SMOKE_STRONG,
            min: 0,
            max: undefined,
            stackLabels: false,
            labelsFormat: '{value}',
            labelsEnabled: true,
        };
        this.columnChartCommonPlotOptionConfigs = {
            maxPointWidth: 32,
            hover: true,
            stacking: 'normal',
            borderWidth: 0,
        };
        this.columnChartCommonChartItems = {
            height: '209',
            width: null,
            type: ChartType.COLUMN,
            margin: [25, 0, 45, 70],
            drawSVGArrow: true,
            spacing: [0, 0, 0, 0],
        };
        this.columnChartCommonTooltipConfigs = {
            showTooltip: true,
            sharedTooltip: true,
        };
    }
    set setDistrictName(input) {
        this.districtName = input;
    }
    set setOrganizationIds(input) {
        this.organizationIds = input;
    }
    set setDistrictIds(input) {
        this.districtIds = input;
    }
    get getDistrictName() {
        return this.districtName;
    }
    get getOrganizationIds() {
        return this.organizationIds;
    }
    activeStudentsAndTeachersData() {
        return this.realizeOverviewDataService.getActiveStudentsAndTeachersData();
    }
    standardsPerformanceByPrograms() {
        return this.realizeOverviewDataService.getStandardsPerformanceByPrograms({
            districtIds: this.districtIds,
        });
    }
    lastExecutedTime() {
        return this.realizeOverviewDataService.getLastExecutedTime();
    }
    engagementBySchools() {
        return this.realizeOverviewDataService.getEngagementBySchools({
            districtIds: this.districtIds,
        });
    }
    activeStudentTeacherEndDateLabel(startingDate) {
        const startDate = new Date(startingDate);
        const endDate = new Date(startDate);
        endDate.setDate(startDate.getDate() + 6);
        const formattedDate = endDate.toLocaleDateString(Locale.EN_US, { month: 'short', day: '2-digit' });
        return formattedDate;
    }
    activeTeacherStudentsChartData(data) {
        return (data || []).map((item) => {
            var _a, _b;
            const dateTime = new Date(item.weekStartDate);
            return {
                label: dateTime.toLocaleDateString(Locale.EN_US, { month: 'short', day: '2-digit' }),
                point1: (_a = item.newUserCount) !== null && _a !== void 0 ? _a : 0,
                point2: (_b = item.returningUserCount) !== null && _b !== void 0 ? _b : 0,
            };
        });
    }
    tooltipHTMLConfig(elem, headers) {
        const startingDate = elem.label;
        const endingDate = this.activeStudentTeacherEndDateLabel(startingDate);
        return `
        <div style="color: ${Colors.GRAY_DARKER};font-size: ${Styles.FONT_SIZE_12};padding: 8px; border-radius: 5px; box-shadow: ${Styles.SHADOW_ELEVATION_THREE}; background-color:${Colors.WHITE}">
        <div style="padding-bottom: 8px; font-family:${Styles.OPEN_SANS_BOLD}">
        ${startingDate} - ${endingDate}
        </div>
        <div style="font-family: ${Styles.POPPINS}; "> ${headers.totalCount} </div>
        <div style="padding-bottom: 8px; font-family:${Styles.OPEN_SANS_BOLD}"> ${elem.point1 + elem.point2} </div>
        <div style="font-family: ${Styles.POPPINS}; ">${headers.newCount} </div>
        <div style="padding-bottom: 8px; font-family:${Styles.OPEN_SANS_BOLD}"> ${elem.point1} </div>
        <div style="font-family: ${Styles.POPPINS}; "> ${headers.returningCount} </div>
        <div style="font-family:${Styles.OPEN_SANS_BOLD}"> ${elem.point2} </div>
        </div>
        `;
    }
}
RealizeOverviewService.ɵfac = function RealizeOverviewService_Factory(t) { return new (t || RealizeOverviewService)(i0.ɵɵinject(i1.RealizeOverviewDataService)); };
RealizeOverviewService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RealizeOverviewService, factory: RealizeOverviewService.ɵfac, providedIn: 'root' });
